export function setMessage(message: string, valueToCompareWith: string): string {
    // Force update if same error message is returned
    const newMessage = message === valueToCompareWith
        ? message + " "
        : message;
    return newMessage;
}